module.exports = __webpack_public_path__ + "img/h8.c05ea5f7.png";